import { useEffect } from "react";

import { APP_NAME } from "./appName";

/** The tab's name follows the screen, because every screen has an address and
 *  a tab named only after the application is one of several identical tabs. */
export function useTitle(screen: string | null) {
  useEffect(() => {
    document.title = screen ? `${screen} - ${APP_NAME}` : APP_NAME;
  }, [screen]);
}
